import stakeChecker from 'functions/saving/objToString/checkers/stakeCheck';
import { numberOfBetsCheck, percentCheck, stopOnCheck } from './autoCheckers'
import { volumeCheck, } from './audioCheckers'
import { booleanCheck, } from './booleanTostringChecker'

export const everyChecker = {
    stake: stakeChecker,
    numberOfBets: numberOfBetsCheck,
    onWinIncrease: booleanCheck,
    onLossIncrease: booleanCheck,
    onWinPercent: percentCheck,
    onLossPercent: percentCheck,
    stopOnWin: stopOnCheck,
    stopOnLoss: stopOnCheck,
    music: booleanCheck,
    sound: booleanCheck,
    volume: volumeCheck
}
